<template>
  <div class="flex h-screen min-h-0 w-full flex-col overflow-hidden bg-[#050505] text-white antialiased md:flex-row">
    <PlusAppSidebar />
    <div class="relative flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-[#050505]">
      <main
        class="plus-pricing relative z-10 mx-auto w-full max-w-[1280px] flex-1 overflow-y-auto overflow-x-hidden overscroll-y-contain px-4 pb-24 pt-8 sm:px-6 sm:pt-12 md:pt-14 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      >
      <!-- 主标题 -->
      <div class="text-center">
        <h1 class="text-balance text-[1.65rem] font-semibold leading-tight tracking-tight sm:text-[2rem]">
          即刻订阅：升级您的 AI 创作之旅
        </h1>
      </div>

      <!-- Pro 促销条（图2：居中双行 + 指定背景图） -->
      <!-- <div class="fp-promo-banner relative mt-10 overflow-hidden rounded-2xl border border-white/[0.1]">
        <div class="fp-promo-bg pointer-events-none absolute inset-0 rounded-2xl" aria-hidden="true"></div>
        <div
          class="fp-promo-overlay pointer-events-none absolute inset-0 rounded-2xl"
          aria-hidden="true"
        ></div>
        <div class="relative z-10 flex flex-col items-center justify-center px-4 py-8 sm:px-10 sm:py-10">
          <div
            class="max-w-full overflow-x-auto pb-0.5 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
          >
            <p
              class="inline-block min-w-0 whitespace-nowrap text-center text-[0.8rem] font-bold leading-tight sm:text-[1.05rem] md:text-[1.15rem]"
            >
              <span class="text-[#e8d5a8]">会员最高 4.6 折优惠</span>
              <span class="text-[#ff7d3f]"> Seedance 2.0 </span>
              <span class="text-[#e8d5a8]">最低仅 0.67 元/秒</span>
            </p>
          </div>
          <div
            class="mt-4 flex max-w-full flex-wrap items-center justify-center gap-x-2 gap-y-2 text-[11px] leading-snug text-white/90 sm:gap-x-3 sm:text-[12px] md:text-[13px]"
          >
            <span
              class="inline-flex items-center gap-1 rounded-md bg-[#2a1212]/95 px-2 py-0.5 ring-1 ring-orange-900/40"
            >
              <i class="fas fa-play translate-x-[0.5px] text-[7px] text-orange-400" aria-hidden="true"></i>
              <span class="text-[11px] font-semibold tracking-wide text-white">Pro</span>
            </span>
            <span class="whitespace-nowrap">
              解锁&nbsp;真人&nbsp;人脸 + 超高并发
              <span class="text-[#f0d78c]">不排队</span>
            </span>
            <span class="whitespace-nowrap">
              年包限时再多送最高 <strong class="font-semibold text-white">10</strong> 万积分
            </span>
            <span
              class="whitespace-nowrap rounded-full border border-white/20 bg-black/40 px-3 py-1 text-[11px] text-white/95 backdrop-blur-sm sm:text-[12px]"
            >
              每月到账8400积分
            </span>
          </div>
        </div>
      </div> -->

      <!-- 计费切换 -->
      <div class="fp-billing-bar mt-10 flex flex-col items-center justify-center">
        <div class="fp-billing-controls">
          <div
            class="fp-billing-segment"
            :class="{ 'fp-billing-segment--solo': !hasYearlySkus }"
            role="tablist"
            aria-label="订阅周期"
          >
            <span
              class="fp-billing-segment__indicator"
              :class="{
                'fp-billing-segment__indicator--yearly': billingTab === 'yearly' && hasYearlySkus
              }"
              aria-hidden="true"
            />
            <button
              type="button"
              role="tab"
              :aria-selected="billingTab === 'monthly'"
              class="fp-billing-segment__tab"
              :class="{ 'fp-billing-segment__tab--active': billingTab === 'monthly' }"
              @click="billingTab = 'monthly'"
            >
              按月订阅
            </button>
            <button
              v-if="hasYearlySkus"
              type="button"
              role="tab"
              :aria-selected="billingTab === 'yearly'"
              class="fp-billing-segment__tab fp-billing-segment__tab--yearly"
              :class="{ 'fp-billing-segment__tab--active': billingTab === 'yearly' }"
              @click="billingTab = 'yearly'"
            >
              <span class="fp-billing-discount-badge" aria-hidden="true">最高优惠54%</span>
              按年订阅
            </button>
          </div>

          <span class="fp-billing-divider" aria-hidden="true" />

          <button
            type="button"
            class="fp-billing-credits"
            :class="{ 'fp-billing-credits--active': creditsModalVisible }"
            @mouseenter="preloadCreditsRechargeData"
            @click="onCreditsTab"
          >
            <span class="fp-billing-credits__icon" aria-hidden="true">
              <i class="fas fa-coins"></i>
            </span>
            <span>会员积分充值</span>
          </button>
        </div>
      </div>

      <p
        v-if="plansError"
        class="mx-auto mt-6 max-w-[1180px] text-center text-[12px] text-amber-200/80"
      >
        {{ plansError }}
      </p>

      <!-- 定价卡（固定宽度，权益区各档对齐） -->
      <div
        v-if="!plansReady"
        class="fp-plans-skeleton mx-auto mt-10 max-w-[1280px] fp-plans-grid fp-plans-grid--cols-4"
        aria-hidden="true"
      >
        <div v-for="n in 4" :key="n" class="fp-plans-skeleton__card" />
      </div>
      <div v-else class="fp-plans-grid mx-auto mt-10 max-w-[1280px]" :class="planGridClass">
        <article
          v-for="(plan, planIdx) in visiblePlans"
          :key="plan.id"
          class="fp-plan-card relative flex w-full flex-col overflow-visible rounded-2xl border p-5 pb-6 shadow-xl"
          :class="planCardShellClass(plan)"
        >
          <div class="relative z-10 flex flex-col">
            <!-- 图2：单行胶囊「图标 + 英文名 - 中文名」不换行 -->
            <div class="min-w-0 pr-14">
              <div
                class="fp-tier-pill inline-flex max-w-full items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-1.5 text-[12px] shadow-[inset_0_1px_0_rgba(255,255,255,0.07)] sm:gap-2 sm:px-3.5 sm:py-2 sm:text-[13px]"
                :class="tierPillClass(plan)"
              >
                <template v-if="plan.playIcon">
                  <svg
                    class="fp-play-tri shrink-0"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    aria-hidden="true"
                  >
                    <defs>
                      <linearGradient :id="'fp-tri-' + plan.id" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stop-color="#ff5c33" />
                        <stop offset="45%" stop-color="#fbbf24" />
                        <stop offset="100%" stop-color="#2dd4bf" />
                      </linearGradient>
                    </defs>
                    <path
                      d="M2.2 1.3 L10.2 6 L2.2 10.7 Z"
                      :fill="'url(#fp-tri-' + plan.id + ')'"
                      stroke="rgba(255,255,255,0.12)"
                      stroke-width="0.3"
                      stroke-linejoin="round"
                    />
                  </svg>
                </template>
                <i v-else :class="[plan.icon, 'shrink-0 text-[13px] text-emerald-400/90']" aria-hidden="true"></i>
                <span class="shrink-0 font-bold tracking-tight text-white">{{ plan.badge }}</span>
                <span class="shrink-0 font-medium text-white/80">&nbsp;-&nbsp;</span>
                <span class="shrink-0 font-medium text-[#b8c4bc]">{{ plan.name }}</span>
              </div>
            </div>

            <!-- 价格（图2：¥ 主价 (琥珀划线原价) /月|/年 同一行；nowrap 避免换行造成「数字在滚」观感） -->
            <div class="fp-plan-figures mt-5 border-t border-white/[0.07] pt-5">
              <div
                class="fp-price-row flex max-w-full flex-nowrap items-baseline gap-x-1 overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
              >
                <span class="shrink-0 text-[13px] text-white/45">¥</span>
                <RollingNumber
                  :value="displayPriceMain(plan)"
                  :duration="480"
                  class="shrink-0 text-[2rem] font-semibold leading-none tracking-tight text-white"
                />
                <span
                  v-if="displayPriceOld(plan)"
                  class="shrink-0 text-[1rem] font-medium tabular-nums text-amber-200/90 line-through decoration-orange-400/50"
                  >(<RollingNumber
                    :value="displayPriceOld(plan)"
                    :duration="480"
                    class="tabular-nums"
                  />)</span
                >
                <span
                  v-if="plan.theme !== 'neutral'"
                  :key="'pu-' + billingTab + '-' + plan.id"
                  class="shrink-0 text-[13px] tabular-nums text-white/38"
                  >{{ planBillingSuffix(plan) }}</span
                >
              </div>
            </div>

            <!-- 积分（图2：大数字 + 彩虹方标 + 按年分色「比月付多 / %」；按月为琥珀括号） -->
            <div
              v-if="plan.theme !== 'neutral'"
              class="fp-credits-row mt-4 flex max-w-full flex-nowrap items-center gap-1.5 overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
            >
              <RollingNumber
                :value="displayCredits(plan)"
                :duration="560"
                class="shrink-0 text-[22px] font-semibold leading-none tracking-tight text-white"
              />
              <span
                class="fp-credits-rainbow inline-block h-[15px] w-[15px] shrink-0 rounded-[3px] ring-1 ring-white/15"
                aria-hidden="true"
              />
              <span
                v-if="billingTab === 'yearly' && plan.creditsYearMorePct"
                :key="'cby-' + plan.id"
                class="shrink-0 text-[13px] font-medium leading-snug"
              >
                <span class="text-orange-200/90">(比月付多 </span>
                <span class="text-sky-300">{{ plan.creditsYearMorePct }}%)</span>
              </span>
              <span v-else-if="plan.creditsBonus" :key="'cbm-' + plan.id" class="shrink-0 text-[13px] font-medium text-amber-200/90">{{
                plan.creditsBonus
              }}</span>
            </div>

            <!-- 迷你走势图：纵向虚线格 + 渐变折线 + 实心数据点（参考 Plus 定价卡） -->
            <div
              v-if="plan.chartStroke"
              class="fp-plan-chart-wrap pointer-events-none mt-2.5 w-full shrink-0 select-none sm:mt-3"
              aria-hidden="true"
            >
              <svg class="fp-plan-chart-svg block h-[76px] w-full sm:h-[82px]" viewBox="0 0 280 90" preserveAspectRatio="none">
                <defs>
                  <linearGradient :id="'fp-chart-line-' + plan.id" x1="0%" y1="50%" x2="100%" y2="50%">
                    <stop offset="0%" :stop-color="plan.chartGradient[0]" stop-opacity="0.95" />
                    <stop offset="45%" :stop-color="plan.chartGradient[0]" stop-opacity="0.75" />
                    <stop offset="100%" :stop-color="plan.chartGradient[1]" stop-opacity="0.55" />
                  </linearGradient>
                  <filter :id="'fp-chart-glow-' + plan.id" x="-30%" y="-30%" width="160%" height="160%">
                    <feGaussianBlur in="SourceGraphic" stdDeviation="1.8" result="b" />
                    <feMerge>
                      <feMergeNode in="b" />
                      <feMergeNode in="SourceGraphic" />
                    </feMerge>
                  </filter>
                </defs>
                <g class="fp-chart-grid" opacity="0.55">
                  <line
                    v-for="(gx, gi) in chartGridXs"
                    :key="'gx-' + plan.id + '-' + gi"
                    :x1="gx"
                    y1="6"
                    :x2="gx"
                    y2="84"
                    stroke="rgba(255,255,255,0.16)"
                    stroke-width="1"
                    stroke-dasharray="2 6"
                    stroke-linecap="round"
                    vector-effect="non-scaling-stroke"
                  />
                </g>
                <path
                  :d="plan.chartPath"
                  fill="none"
                  :stroke="'url(#fp-chart-line-' + plan.id + ')'"
                  stroke-width="2.35"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  :filter="'url(#fp-chart-glow-' + plan.id + ')'"
                  opacity="0.88"
                />
                <g v-if="plan.chartDots && plan.chartDots.length">
                  <circle
                    v-for="(dot, di) in plan.chartDots"
                    :key="'dh-' + plan.id + '-' + di"
                    :cx="dot.x"
                    :cy="dot.y"
                    :r="(dot.r || 3.5) + 3.2"
                    :fill="chartDotHaloFill(plan)"
                    opacity="0.22"
                  />
                  <circle
                    v-for="(dot, di) in plan.chartDots"
                    :key="'d-' + plan.id + '-' + di"
                    :cx="dot.x"
                    :cy="dot.y"
                    :r="dot.r || 3.5"
                    :fill="chartDotFill(plan, di)"
                    stroke="rgba(255,255,255,0.38)"
                    stroke-width="0.75"
                    :filter="'url(#fp-chart-glow-' + plan.id + ')'"
                  />
                </g>
              </svg>
            </div>

            <button
              type="button"
              class="fp-cta relative mt-4 w-full overflow-hidden rounded-full py-2.5 text-[13px] font-semibold transition sm:mt-5 disabled:cursor-not-allowed disabled:opacity-55"
              :class="planCtaClass(plan)"
              :disabled="orderSubmitting"
              @click="onPlanCta(plan)"
            >
              <span
                v-if="plan.theme !== 'neutral'"
                class="pointer-events-none absolute inset-0 z-0 overflow-hidden rounded-full"
              >
                <span
                  class="fp-cta-shine"
                  :style="{ animationDelay: planIdx * 0.5 + 's' }"
                  aria-hidden="true"
                />
              </span>
              <span class="relative z-10">{{
                orderSubmitting && orderingPlanId === plan.id ? '提交中…' : plan.cta
              }}</span>
            </button>

            <section class="fp-plan-data mt-6 space-y-4 text-[11px] leading-relaxed sm:text-[12px]">
              <div>
                <!-- <h4 class="text-[11px] font-semibold uppercase tracking-wide text-white/35">创作补贴</h4> -->
                <ul class="mt-2 space-y-1.5 text-white/55">
                  <li v-for="(line, i) in plan.subsidy" :key="'s' + i" class="truncate">{{ line }}</li>
                </ul>
              </div>
              <div>
                <!-- <h4 class="text-[11px] font-semibold uppercase tracking-wide text-white/35">模型权益</h4> -->
                <div class="mt-2 space-y-2.5">
                  <div v-for="(row, i) in plan.modelRows" :key="'m' + i" class="space-y-0.5">
                    <div class="fp-data-row flex items-center gap-2 text-white/75">
                      <span class="fp-data-row__label min-w-0 flex-1 truncate">{{ row.label }}</span>
                      <span class="fp-data-row__leader min-h-px min-w-[8px] flex-[0_1_24px] border-b border-dotted border-white/20"></span>
                      <span class="fp-data-row__value shrink-0 whitespace-nowrap text-right text-white/90">{{ row.value }}</span>
                    </div>
                    <p v-if="row.sub" class="pl-0 text-[10px] leading-snug text-white/35">{{ row.sub }}</p>
                    <p v-if="row.sub2" class="flex flex-wrap items-center gap-1 text-[10px] text-white/40">
                      <span>{{ row.sub2 }}</span>
                      <span
                        v-if="row.sota"
                        class="rounded bg-orange-500/25 px-1 py-px text-[9px] font-bold text-orange-300"
                        >SOTA</span
                      >
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <h4 class="text-[11px] font-semibold uppercase tracking-wide text-white/35">使用权益</h4>
                <ul class="mt-2 space-y-1.5 text-white/55">
                  <li v-for="(line, i) in plan.usage" :key="'u' + i" class="flex min-w-0 items-start gap-1.5 truncate">
                    <span class="min-w-0 truncate">{{ line.text }}</span>
                    <span
                      v-if="line.new"
                      class="shrink-0 rounded bg-emerald-500/20 px-1 text-[9px] font-bold text-emerald-400"
                      >New</span
                    >
                  </li>
                </ul>
              </div>
            </section>
          </div>

          <!-- 右上角折扣角标：图2 悬浮压边（勿放在 overflow-hidden 内，避免裁切） -->
          <div
            v-if="plan.discountChip"
            class="fp-discount-chip pointer-events-none absolute right-3 top-0 z-30 -translate-y-1/2 rounded-full border px-2.5 py-1 text-[11px] font-semibold tracking-wide"
            :class="'fp-discount-chip--' + plan.theme"
          >
            {{ plan.discountChip }}
          </div>
        </article>
      </div>

      <!-- <p class="mt-6 text-center text-[11px] leading-relaxed text-[#555]">
        套餐价格与权益以接口
        <span class="text-white/50">/vip-skus</span>
        及实际结算页为准；下单前请确认当前 SKU 信息。
      </p> -->

      <!-- FAQ -->
      <section class="mx-auto mt-20 max-w-[900px]">
        <h2 class="text-center text-[1.35rem] font-semibold text-white">idoing 订阅与积分常见问题</h2>
        <div class="mt-8 space-y-2">
          <div
            v-for="(item, idx) in faqItems"
            :key="idx"
            class="overflow-hidden rounded-xl border border-white/[0.06] bg-[#0a0a0a]"
          >
            <button
              type="button"
              class="flex w-full items-center gap-3 px-4 py-4 text-left text-[14px] font-medium text-white/95 transition hover:bg-white/[0.03]"
              @click="toggleFaq(idx)"
            >
              <span
                class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white/[0.06] text-[12px] text-[#888]"
                >{{ idx + 1 }}</span
              >
              <span class="flex-1">{{ item.q }}</span>
              <i :class="['fas text-[11px] text-[#666]', openFaq === idx ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
            </button>
            <div
              v-show="openFaq === idx"
              class="border-t border-white/[0.05] px-4 pb-4 pt-0 text-[13px] leading-relaxed text-[#a8a8a8]"
            >
              <div class="prose-plus pt-3" v-html="item.aHtml"></div>
            </div>
          </div>
        </div>

        <div class="mt-10 rounded-xl border border-white/[0.06] bg-[#0a0a0a] p-5 text-[13px] leading-relaxed text-[#9a9a9a]">
          <h3 class="text-[14px] font-semibold text-white">免责声明与联系方式</h3>
          <p class="mt-3">
            💬 如有关于<strong class="text-white/90">订阅或积分</strong>的问题，欢迎联系
            <a class="text-sky-400 no-underline hover:underline" href="mailto:pluskeji@126.com">pluskeji@126.com</a>。
          </p>
          <p class="mt-3">
            ⚠️ idoing 会根据产品优化与用户体验需要，不断调整功能、价格、订阅方案及积分政策。上述内容仅供参考，可能会在提前通知或不提前通知的情况下进行变更。如出现争议或不一致情况，以
            <router-link class="text-sky-400 no-underline hover:underline" to="/terms">官方服务条款</router-link>、系统记录与实际账单数据为准。
          </p>
        </div>
      </section>
    </main>
    </div>

    <CreditsRechargeModal
      :visible="creditsModalVisible"
      :user-name="creditsProfile.name"
      :avatar="creditsProfile.avatar"
      :vipname="creditsProfile.vipname"
      :vip-end-at="creditsProfile.vipEndAt"
      :level-label="creditsProfile.levelLabel"
      :is-member="creditsProfile.isMember"
      :balance="creditsProfile.score"
      :packs="creditPacks"
      :submitting="creditsOrderSubmitting"
      :selected-id="selectedCreditPackId"
      @close="closeCreditsModal"
      @select="onSelectCreditPack"
      @purchase="submitCreditsOrder"
      @upgrade-member="onCreditsUpgradeMember"
    />

    <VipPayModal
      :visible="payModalVisible"
      :title="payModal.title"
      :price-main="payModal.priceMain"
      :price-old="payModal.priceOld"
      :discount-label="payModal.discountLabel"
      :qr-code="payModal.qrCode"
      :renew-note="payModal.renewNote"
      :expire-seconds="payModal.expireSeconds"
      @close="closePayModal"
      @expired="onPayExpired"
    />
  </div>
</template>

<script>
import PlusAppSidebar from '../components/PlusAppSidebar.vue'
import RollingNumber from '../components/RollingNumber.vue'
import CreditsRechargeModal from '../components/CreditsRechargeModal.vue'
import VipPayModal from '../components/VipPayModal.vue'
import { openLoginModal, hasAuthToken, loginGate } from '../utils/loginGate'
import { showSuccessToast, showErrorToast } from '../utils/toast'
import {
  FREE_PLAN,
  createVipOrder,
  buildVipPayModalPayload,
  extractVipOrderId,
  scanAlipayPayment,
  isAlipayPaymentPaid,
  getApiErrorMessage,
  resolveVipOrderPayment,
  getVipOrderPaymentFailureMessage
} from '../utils/vipSkuApi'
import {
  getVipPlansCacheSnapshot,
  prefetchVipPlans,
  refreshVipPlans,
  invalidateVipPlansCache
} from '../utils/vipPlansCache'
import {
  fetchCreditRechargePacks,
  fetchCreditsUserProfile,
  createScoreOrder,
  DEFAULT_CREDIT_PACKS,
  getApiErrorMessage as getCreditsApiErrorMessage
} from '../utils/creditsRechargeApi'

const PAY_POLL_INTERVAL_MS = 2500

const FP_CHART_GRID_X = [12, 44, 76, 108, 140, 172, 204, 236, 268]

const FAQ = [
  {
    q: '什么是积分（credits），我如何获得？',
    aHtml: `<p>积分是 idoing 平台的标准计量单位。当你通过<strong class="text-white/90">对话、故事板或其他创作工具</strong>开始创作时，系统会根据所使用的<strong class="text-white/90">模型类型、生成时长、分辨率</strong>及其他相关参数自动扣除相应积分。</p>
<p class="mt-3">你可以通过两种方式获取积分：</p>
<ul class="mt-2 list-disc space-y-1 pl-5">
<li><strong class="text-white/90">订阅获取积分</strong>：订阅任意会员后，可获取固定额度的月度积分，有效期为 <strong class="text-white/90">30 天</strong>；</li>
<li><strong class="text-white/90">免费与奖励积分</strong>：每周积分（Weekly Credits）、邀请奖励、探索使用奖励、超创/活动奖励等，具体规则以官网为准。</li>
</ul>
<p class="mt-3 text-amber-200/80">⚠️ 积分规则、奖励政策及相关活动机制可能会根据运营需要进行调整。在法律允许范围内，idoing 保留相关规则的最终解释权。</p>`
  },
  {
    q: '积分在使用过程中如何扣除？',
    aHtml: `<p><strong class="text-white/90">积分计费规则</strong>：积分的具体消耗以各节点显示所需积分为准。</p>
<p class="mt-3"><strong class="text-white/90">积分扣除顺序</strong>：系统将优先扣除更快到期的积分。</p>
<p class="mt-3 text-amber-200/80">⚠️ 免费使用期间将启用防刷与防自动化滥用机制。</p>`
  },
  {
    q: '订阅是如何运作的？',
    aHtml: `<p>idoing 提供灵活的<strong class="text-white/90">月度与年度订阅方案</strong>，每个方案都包含一定数量的积分，可用于对话、图像生成、视频生成、音乐与旁白生成、编辑等功能。</p>
<p class="mt-3">当你升级订阅时：旧套餐按已使用积分比例计费；剩余未使用余额将自动扣抵至新套餐；你仅需支付补齐差价；新的订阅周期将从升级当日重新计算。</p>`
  },
  // {
  //   q: '订阅会自动续费吗？',
  //   aHtml: `<p>会的。订阅将在每个计费周期结束时<strong class="text-white/90">自动续费</strong>，除非你在续费日前主动取消。</p>`
  // },
  {
    q: '限时优惠活动如何生效？',
    aHtml: `<p>在促销期间订阅，优惠权益会立即生效；若你取消订阅，相关促销权益将同步失效；若你在同一促销期内重新订阅，剩余优惠权益在符合规则的情况下予以恢复。</p>`
  },
//   {
//     q: '如何修改或取消订阅？',
//     aHtml: `<p>你可以随时进行升级：<strong class="text-white/90">Starter → Basic → Pro</strong>；<strong class="text-white/90">按月付费 → 按年付费</strong>。</p>
// <p class="mt-3">取消订阅：进入订阅页面 → 点击「Manage Subscription（管理订阅）」→ 选择「Cancel Subscription（取消订阅）」。取消后，你仍可在当前订阅周期内继续使用订阅权益。</p>`
//   },
  {
    q: '我如何申请退款？',
    aHtml: `<p>若你在最近一次付款后<strong class="text-white/90">未有任何生成行为</strong>，可在购买后 <strong class="text-white/90">7 天内</strong>申请全额退款。若因系统问题导致生成失败，将自动退还相应积分。</p>
<p class="mt-3">若需申请退款，请联系 <a class="text-sky-400 no-underline hover:underline" href="mailto:pluskeji@126.com">pluskeji@126.com</a>。退款通常会在 <strong class="text-white/90">5–10 个工作日</strong>内退回原支付方式。</p>`
  }
]

export default {
  name: 'PlusPricing',
  components: {
    PlusAppSidebar,
    RollingNumber,
    CreditsRechargeModal,
    VipPayModal
  },
  data() {
    const cachedPlans = getVipPlansCacheSnapshot()
    return {
      loginGate,
      billingTab: 'monthly',
      plans: cachedPlans?.plans?.length ? cachedPlans.plans : [FREE_PLAN],
      hasYearlySkus: cachedPlans?.hasYearly ?? false,
      plansReady: !!cachedPlans,
      plansPreloadPromise: null,
      plansError: '',
      orderSubmitting: false,
      orderingPlanId: '',
      pendingOrderPlan: null,
      currentCoupon: null,
      creditsModalVisible: false,
      creditsPreloadPromise: null,
      creditsOrderSubmitting: false,
      creditPacks: [],
      selectedCreditPackId: '',
      selectedCreditPack: null,
      pendingCreditsRecharge: false,
      creditsProfile: {
        name: '用户',
        avatar: '',
        score: 0,
        vipname: 'FREE',
        vipEndAt: '',
        levelLabel: 'FREE 工作室',
        isMember: false
      },
      payModalVisible: false,
      payOrderId: null,
      payFromCredits: false,
      payPollTimerId: null,
      payPollInFlight: false,
      payModal: {
        title: '',
        priceMain: '0',
        priceOld: '',
        discountLabel: '',
        qrCode: '',
        renewNote: '',
        expireSeconds: 900
      },
      faqItems: FAQ,
      openFaq: 0,
      chartGridXs: FP_CHART_GRID_X
    }
  },
  computed: {
    visiblePlans() {
      const tab = this.billingTab
      return (this.plans || []).filter(plan => {
        if (plan.theme === 'neutral') return tab === 'monthly'
        const days = Number(plan.billingDays) || 30
        if (tab === 'yearly') return days >= 300
        return days < 300
      })
    },
    planGridClass() {
      const n = this.visiblePlans.length
      if (n >= 4) return 'fp-plans-grid--cols-4'
      if (n === 3) return 'fp-plans-grid--cols-3'
      if (n === 2) return 'fp-plans-grid--cols-2'
      return 'fp-plans-grid--cols-1'
    }
  },
  mounted() {
    this.loadVipPlans({ silent: true, revalidate: true })
    this.preloadCreditsRechargeData()
    this.tryOpenRechargeFromQuery()
  },
  watch: {
    '$route.query.recharge'(v) {
      if (v) this.tryOpenRechargeFromQuery()
    },
    'loginGate.visible'(visible) {
      if (visible || !hasAuthToken()) return
      if (this.pendingOrderPlan) {
        const plan = this.pendingOrderPlan
        this.pendingOrderPlan = null
        this.submitVipOrder(plan)
        return
      }
      if (this.pendingCreditsRecharge) {
        this.pendingCreditsRecharge = false
        this.preloadCreditsRechargeData().finally(() => this.openCreditsModal())
      } else {
        this.preloadCreditsRechargeData()
        this.loadVipPlans({ silent: true, revalidate: true })
      }
    }
  },
  methods: {
    preloadVipPlans() {
      if (this.plansPreloadPromise) return this.plansPreloadPromise
      this.plansPreloadPromise = this.loadVipPlans({ silent: true }).finally(() => {
        this.plansPreloadPromise = null
      })
      return this.plansPreloadPromise
    },
    applyVipPlansPayload({ plans, hasYearly }) {
      if (plans && plans.length) this.plans = plans
      this.hasYearlySkus = !!hasYearly
      if (this.billingTab === 'yearly' && !this.hasYearlySkus) {
        this.billingTab = 'monthly'
      }
    },
    async loadVipPlans(opts = {}) {
      const silent = opts.silent !== false
      const revalidate = opts.revalidate === true
      const force = opts.force === true
      this.plansError = ''
      try {
        const loader = revalidate || force ? refreshVipPlans : prefetchVipPlans
        const payload = await loader({ force })
        this.applyVipPlansPayload(payload)
      } catch (e) {
        this.plansError = (e && e.message) || '套餐加载失败，请稍后重试'
        if (!this.plans || this.plans.length <= 1) {
          this.plans = [FREE_PLAN]
        }
        if (!silent) {
          showErrorToast(this.plansError)
        }
      } finally {
        this.plansReady = true
      }
    },
    planBillingSuffix(plan) {
      if (!plan || plan.theme === 'neutral') return ''
      const days = Number(plan.billingDays) || 30
      return days >= 300 ? '/年' : '/月'
    },
    tierPillClass(plan) {
      if (plan.theme === 'neutral') {
        return 'fp-tier-pill--neutral border-white/[0.1]'
      }
      if (plan.theme === 'green') {
        return 'fp-tier-pill--green border-emerald-800/40'
      }
      if (plan.theme === 'orange') {
        return 'fp-tier-pill--orange border-orange-900/35'
      }
      if (plan.theme === 'red') {
        return 'fp-tier-pill--red border-red-900/40'
      }
      return ''
    },
    planCardShellClass(plan) {
      if (plan.theme === 'neutral') {
        return 'border-white/[0.08] bg-[#111111]'
      }
      if (plan.theme === 'green') {
        return 'border-emerald-500/35 bg-[#0f1612] shadow-[0_0_48px_-16px_rgba(16,185,129,0.45)]'
      }
      if (plan.theme === 'orange') {
        return 'border-orange-500/35 bg-[#161210] shadow-[0_0_48px_-16px_rgba(251,146,60,0.4)]'
      }
      if (plan.theme === 'red') {
        return 'border-red-500/40 bg-[#160f0f] shadow-[0_0_52px_-14px_rgba(248,113,113,0.45)]'
      }
      return 'border-white/[0.08] bg-[#111]'
    },
    planCtaClass(plan) {
      if (plan.theme === 'neutral') {
        return 'rounded-full border border-white/[0.1] bg-[#252525] text-white hover:bg-[#2e2e2e]'
      }
      if (plan.theme === 'green') {
        return 'bg-gradient-to-r from-teal-300 via-emerald-400 to-emerald-700 text-white shadow-lg hover:brightness-110 active:brightness-95'
      }
      if (plan.theme === 'orange') {
        return 'bg-gradient-to-r from-amber-300 via-orange-400 to-orange-700 text-white shadow-lg hover:brightness-110 active:brightness-95'
      }
      if (plan.theme === 'red') {
        return 'bg-gradient-to-r from-rose-400 via-red-500 to-red-800 text-white shadow-lg hover:brightness-110 active:brightness-95'
      }
      return 'bg-white text-slate-900'
    },
    displayPriceMain(plan) {
      return plan.priceMain
    },
    displayPriceOld(plan) {
      return plan.priceOld || null
    },
    displayCredits(plan) {
      if (plan.theme === 'neutral') return plan.monthlyCredits
      return plan.monthlyCredits
    },
    chartDotFill(plan, index) {
      const dots = plan.chartDots
      if (!dots || !dots.length) return '#fff'
      const last = index === dots.length - 1
      if (plan.theme === 'green') return last ? '#ecfdf5' : '#4ade80'
      if (plan.theme === 'orange') return last ? '#fffbeb' : '#fb923c'
      if (plan.theme === 'red') return last ? '#fff1f2' : '#fb7185'
      return '#fff'
    },
    chartDotHaloFill(plan) {
      if (plan.theme === 'green') return '#34d399'
      if (plan.theme === 'orange') return '#fb923c'
      if (plan.theme === 'red') return '#f87171'
      return '#94a3b8'
    },
    tryOpenRechargeFromQuery() {
      const q = this.$route && this.$route.query
      if (!q || q.recharge !== '1') return
      if (!hasAuthToken()) {
        this.pendingCreditsRecharge = true
        openLoginModal()
        return
      }
      this.preloadCreditsRechargeData().finally(() => {
        this.openCreditsModal()
        this.$router.replace({ path: '/pricing', query: {} }).catch(() => {})
      })
    },
    onCreditsTab() {
      if (!hasAuthToken()) {
        this.pendingCreditsRecharge = true
        openLoginModal()
        return
      }
      this.openCreditsModal()
    },
    applyCreditPackSelection(packs) {
      const list = packs && packs.length ? packs : DEFAULT_CREDIT_PACKS
      this.creditPacks = list
      const keepId = this.selectedCreditPackId
      const kept = keepId ? list.find(p => p.id === keepId) : null
      const pick = kept || list[0]
      if (pick) {
        this.selectedCreditPackId = pick.id
        this.selectedCreditPack = pick
      }
    },
    preloadCreditsRechargeData() {
      if (!hasAuthToken()) return Promise.resolve()
      if (this.creditsPreloadPromise) return this.creditsPreloadPromise
      this.creditsPreloadPromise = this.refreshCreditsRechargeData({ silent: true }).finally(() => {
        this.creditsPreloadPromise = null
      })
      return this.creditsPreloadPromise
    },
    async refreshCreditsRechargeData(opts = {}) {
      const silent = opts.silent !== false
      if (!hasAuthToken()) return
      try {
        const [packs, profile] = await Promise.all([
          fetchCreditRechargePacks(),
          fetchCreditsUserProfile().catch(() => null)
        ])
        this.applyCreditPackSelection(packs)
        if (profile) this.creditsProfile = profile
      } catch (e) {
        if (!this.creditPacks.length) {
          this.applyCreditPackSelection(DEFAULT_CREDIT_PACKS)
        }
        if (!silent) {
          showErrorToast((e && e.message) || '加载充值档位失败')
        }
      }
    },
    openCreditsModal() {
      if (!this.creditPacks.length) {
        this.applyCreditPackSelection(DEFAULT_CREDIT_PACKS)
      } else if (!this.selectedCreditPackId) {
        this.applyCreditPackSelection(this.creditPacks)
      }
      this.creditsModalVisible = true
      this.refreshCreditsRechargeData({ silent: true })
    },
    closeCreditsModal() {
      this.creditsModalVisible = false
      this.selectedCreditPackId = ''
      this.selectedCreditPack = null
    },
    onSelectCreditPack(pack) {
      this.selectedCreditPackId = pack.id
      this.selectedCreditPack = pack
    },
    onCreditsUpgradeMember() {
      this.closeCreditsModal()
      this.billingTab = 'monthly'
      const main = document.querySelector('.plus-pricing')
      if (main) main.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    async submitCreditsOrder() {
      const pack = this.selectedCreditPack
      if (!pack) {
        showErrorToast('请选择充值档位')
        return
      }
      if (!pack.skuId) {
        showErrorToast('该档位暂未配置商品，请联系客服或稍后再试')
        return
      }
      if (this.creditsOrderSubmitting) return
      this.creditsOrderSubmitting = true
      try {
        const order = await createScoreOrder({ skuId: pack.skuId })
        const pay = resolveVipOrderPayment(order)
        if (pay.qrCode) {
          this.closeCreditsModal()
          this.payFromCredits = true
          this.payOrderId = pay.orderId
          this.payModal = {
            ...buildVipPayModalPayload(order, null),
            title: `积分充值 ${this.formatCreditPoints(pack.points)} 积分`,
            priceMain: String(pack.price)
          }
          this.payModalVisible = true
          this.$nextTick(() => this.startPayStatusPoll())
          return
        }
        if (pay.payUrl) {
          window.location.href = pay.payUrl
          return
        }
        showErrorToast(getVipOrderPaymentFailureMessage(order))
      } catch (e) {
        showErrorToast(getCreditsApiErrorMessage(e, getApiErrorMessage(e, '充值下单失败')))
      } finally {
        this.creditsOrderSubmitting = false
      }
    },
    formatCreditPoints(n) {
      const v = Number(n)
      if (!Number.isFinite(v)) return '0'
      return v.toLocaleString('en-US')
    },
    toggleFaq(idx) {
      this.openFaq = this.openFaq === idx ? -1 : idx
    },
    onPlanCta(plan) {
      if (plan.id === 'free') {
        this.$router.push('/')
        return
      }
      if (!plan.skuId) {
        showErrorToast('套餐信息无效，请刷新后重试')
        return
      }
      if (!hasAuthToken()) {
        this.pendingOrderPlan = plan
        openLoginModal()
        return
      }
      this.submitVipOrder(plan)
    },
    async submitVipOrder(plan) {
      if (this.orderSubmitting) return
      const skuId = plan.skuId
      if (!skuId) {
        showErrorToast('套餐信息无效')
        return
      }
      this.orderSubmitting = true
      this.orderingPlanId = plan.id
      try {
        const couponId =
          this.currentCoupon && this.currentCoupon.id != null ? this.currentCoupon.id : undefined
        const order = await createVipOrder({ skuId, couponId })
        const pay = resolveVipOrderPayment(order)
        if (pay.qrCode) {
          this.openPayModal(order, plan)
          return
        }
        if (pay.payUrl) {
          window.location.href = pay.payUrl
          return
        }
        showErrorToast(getVipOrderPaymentFailureMessage(order))
      } catch (e) {
        const msg = getApiErrorMessage(e, '提交订单失败')
        if (/登录|token|未授权|401/i.test(msg)) {
          this.pendingOrderPlan = plan
          openLoginModal()
        } else {
          showErrorToast(msg)
        }
      } finally {
        this.orderSubmitting = false
        this.orderingPlanId = ''
      }
    },
    openPayModal(order, plan) {
      this.payFromCredits = false
      this.payOrderId = extractVipOrderId(order)
      this.payModal = buildVipPayModalPayload(order, plan)
      if (!this.payOrderId && process.env.NODE_ENV === 'development') {
        console.warn('[vip-pay] 未解析到 order_id，无法轮询支付状态', order)
      }
      this.payModalVisible = true
      this.$nextTick(() => this.startPayStatusPoll())
    },
    startPayStatusPoll() {
      this.stopPayStatusPoll()
      if (!this.payModalVisible || this.payOrderId == null || this.payOrderId === '') return
      this.checkPayStatusOnce()
      this.payPollTimerId = window.setInterval(() => {
        this.checkPayStatusOnce()
      }, PAY_POLL_INTERVAL_MS)
    },
    stopPayStatusPoll() {
      if (this.payPollTimerId != null) {
        clearInterval(this.payPollTimerId)
        this.payPollTimerId = null
      }
      this.payPollInFlight = false
    },
    async checkPayStatusOnce() {
      if (!this.payModalVisible || this.payOrderId == null || this.payOrderId === '') return
      if (this.payPollInFlight) return
      this.payPollInFlight = true
      try {
        const res = await scanAlipayPayment(this.payOrderId)
        if (isAlipayPaymentPaid(res)) {
          this.onVipPaymentComplete()
        }
      } catch (e) {
        if (process.env.NODE_ENV === 'development') {
          console.warn('[vip-pay] scan_alipay 请求失败', e)
        }
      } finally {
        this.payPollInFlight = false
      }
    },
    closePayModal() {
      this.payModalVisible = false
      this.stopPayStatusPoll()
      this.payOrderId = null
    },
    onVipPaymentComplete() {
      if (!this.payModalVisible && this.payPollTimerId == null) return
      this.stopPayStatusPoll()
      this.payModalVisible = false
      this.payOrderId = null
      const wasCredits = this.payFromCredits
      this.payFromCredits = false
      showSuccessToast(wasCredits ? '支付成功，积分已到账' : '支付成功，会员已开通')
      if (wasCredits) {
        fetchCreditsUserProfile()
          .then(p => {
            if (p) this.creditsProfile = p
          })
          .catch(() => {})
      } else {
        invalidateVipPlansCache()
        this.loadVipPlans({ silent: true, force: true })
      }
    },
    onPayExpired() {
      this.payModalVisible = false
      this.stopPayStatusPoll()
      this.payOrderId = null
      showErrorToast('支付已超时，请重新下单')
    }
  },
  beforeDestroy() {
    if (this.payPollTimerId != null) {
      clearInterval(this.payPollTimerId)
      this.payPollTimerId = null
    }
  }
}
</script>

<style scoped>
.plus-pricing {
  font-family:
    ui-sans-serif,
    system-ui,
    -apple-system,
    'Segoe UI',
    Roboto,
    'PingFang SC',
    'Microsoft YaHei',
    sans-serif;
}
/* 切换月/年时：普通文案不继承过渡；数字滚动由 RollingNumber 自带动画 */
.fp-plan-figures span:not(.rolling-number),
.fp-price-row span:not(.rolling-number),
.fp-credits-row span:not(.rolling-number) {
  transition: none !important;
  animation: none !important;
}
.prose-plus :deep(p) {
  margin-bottom: 0.5rem;
}
.prose-plus :deep(p:last-child) {
  margin-bottom: 0;
}
.prose-plus :deep(ul) {
  margin: 0.5rem 0 0;
}
.fp-promo-bg {
  background-image: url('https://plusyifanshang.oss-cn-hangzhou.aliyuncs.com/box/img/other/qpzsEgTDsU5mN6vLw4C5afLarxu9pqN9v9llWWBC.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.fp-promo-overlay {
  background: linear-gradient(180deg, rgba(5, 5, 8, 0.2) 0%, rgba(5, 5, 8, 0.45) 100%);
}
.fp-promo-banner {
  box-shadow: 0 24px 60px -24px rgba(0, 0, 0, 0.75);
}

/* 计费切换：滑动指示器 + 玻璃质感 */
.fp-billing-bar {
  padding-top: 10px;
}
.fp-billing-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.fp-billing-segment {
  position: relative;
  display: inline-grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  padding: 4px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.09);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.07) 0%, rgba(255, 255, 255, 0.02) 100%),
    rgba(10, 10, 14, 0.78);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.07),
    0 10px 36px -14px rgba(0, 0, 0, 0.72);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}
.fp-billing-segment--solo {
  grid-template-columns: 1fr;
}
.fp-billing-segment__indicator {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 4px;
  z-index: 0;
  width: calc((100% - 8px) / 2);
  border-radius: 999px;
  background: linear-gradient(145deg, #f8fafc 0%, #ffffff 42%, #e0f2fe 100%);
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.06),
    0 6px 18px rgba(56, 189, 248, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.95);
  transition: transform 0.34s cubic-bezier(0.34, 1.35, 0.64, 1);
  pointer-events: none;
}
.fp-billing-segment--solo .fp-billing-segment__indicator {
  width: calc(100% - 8px);
}
.fp-billing-segment__indicator--yearly {
  transform: translateX(100%);
}
.fp-billing-segment__tab {
  position: relative;
  z-index: 1;
  min-width: 112px;
  padding: 10px 20px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.52);
  cursor: pointer;
  transition: color 0.22s ease;
}
.fp-billing-segment__tab:hover:not(.fp-billing-segment__tab--active) {
  color: rgba(255, 255, 255, 0.84);
}
.fp-billing-segment__tab--active {
  color: #0f172a;
}
.fp-billing-segment__tab--yearly {
  position: relative;
}
.fp-billing-discount-badge {
  position: absolute;
  top: -28px;
  left: 50%;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 7px;
  background: linear-gradient(135deg, #ff5a1f 0%, #ff8a3d 52%, #ffb347 100%);
  box-shadow:
    0 2px 10px rgba(255, 90, 31, 0.42),
    inset 0 1px 0 rgba(255, 255, 255, 0.32);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: #fff;
  white-space: nowrap;
  pointer-events: none;
  transform: translateX(-50%);
  animation: fp-billing-badge-float 3.2s ease-in-out infinite;
}
.fp-billing-discount-badge::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #ff8a3d;
}
@keyframes fp-billing-badge-float {
  0%,
  100% {
    transform: translateX(-50%) translateY(0);
  }
  50% {
    transform: translateX(-50%) translateY(-2px);
  }
}
.fp-billing-divider {
  display: none;
  flex-shrink: 0;
  width: 1px;
  height: 30px;
  background: linear-gradient(180deg, transparent, rgba(255, 255, 255, 0.14), transparent);
}
@media (min-width: 640px) {
  .fp-billing-controls {
    gap: 14px;
  }
  .fp-billing-divider {
    display: block;
  }
}
.fp-billing-credits {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 9px 18px 9px 10px;
  border-radius: 999px;
  border: 1px solid rgba(251, 191, 36, 0.2);
  background:
    linear-gradient(180deg, rgba(251, 191, 36, 0.1) 0%, rgba(251, 191, 36, 0.02) 100%),
    rgba(14, 12, 8, 0.82);
  color: rgba(255, 248, 235, 0.92);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition:
    border-color 0.22s ease,
    background 0.22s ease,
    box-shadow 0.22s ease,
    color 0.22s ease;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 6px 22px -10px rgba(251, 191, 36, 0.28);
}
.fp-billing-credits:hover {
  border-color: rgba(251, 191, 36, 0.42);
  background:
    linear-gradient(180deg, rgba(251, 191, 36, 0.16) 0%, rgba(251, 191, 36, 0.05) 100%),
    rgba(18, 14, 8, 0.9);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    0 8px 28px -8px rgba(251, 191, 36, 0.38);
  color: #fff;
}
.fp-billing-credits--active {
  border-color: rgba(251, 191, 36, 0.55);
  background: linear-gradient(180deg, rgba(251, 191, 36, 0.2) 0%, rgba(251, 191, 36, 0.07) 100%);
  box-shadow:
    0 0 0 1px rgba(251, 191, 36, 0.12),
    0 10px 32px -10px rgba(251, 191, 36, 0.45);
  color: #fffbeb;
}
.fp-billing-credits__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: linear-gradient(145deg, rgba(251, 191, 36, 0.38) 0%, rgba(217, 119, 6, 0.18) 100%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.18),
    0 2px 8px rgba(251, 191, 36, 0.25);
  font-size: 13px;
  color: #fde68a;
}
@media (prefers-reduced-motion: reduce) {
  .fp-billing-segment__indicator {
    transition: none;
  }
  .fp-billing-discount-badge {
    animation: none;
  }
}

.fp-tier-pill--neutral {
  background: rgba(24, 24, 26, 0.92);
}
.fp-tier-pill--green {
  background: rgba(38, 54, 44, 0.92);
}
.fp-tier-pill--orange {
  background: rgba(52, 38, 28, 0.92);
}
.fp-tier-pill--red {
  background: rgba(48, 28, 30, 0.92);
}
.fp-play-tri {
  filter: drop-shadow(0 0 5px rgba(255, 90, 60, 0.45)) drop-shadow(0 0 4px rgba(45, 212, 191, 0.35));
}
.fp-credits-rainbow {
  background: linear-gradient(135deg, #ff5c33 0%, #fbbf24 42%, #38bdf8 100%);
  box-shadow: 0 0 10px rgba(251, 191, 36, 0.28);
}

/* 套餐卡固定宽度，底部权益数据列对齐 */
.fp-plans-grid {
  --fp-plan-card-w: 304px;
  display: grid;
  justify-content: center;
  gap: 16px;
}
.fp-plans-skeleton__card {
  width: var(--fp-plan-card-w);
  max-width: 100%;
  height: 520px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0.03) 0%,
    rgba(255, 255, 255, 0.07) 45%,
    rgba(255, 255, 255, 0.03) 90%
  );
  background-size: 200% 100%;
  animation: fp-plans-skeleton-shimmer 1.4s ease-in-out infinite;
}
@keyframes fp-plans-skeleton-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .fp-plans-skeleton__card {
    animation: none;
    background: rgba(255, 255, 255, 0.04);
  }
}
.fp-plans-grid--cols-1 {
  grid-template-columns: var(--fp-plan-card-w);
}
.fp-plans-grid--cols-2 {
  grid-template-columns: repeat(2, var(--fp-plan-card-w));
}
.fp-plans-grid--cols-3 {
  grid-template-columns: repeat(3, var(--fp-plan-card-w));
}
.fp-plans-grid--cols-4 {
  grid-template-columns: repeat(4, var(--fp-plan-card-w));
}
@media (max-width: 1280px) {
  .fp-plans-grid--cols-4 {
    grid-template-columns: repeat(2, var(--fp-plan-card-w));
  }
}
@media (max-width: 660px) {
  .fp-plans-grid--cols-2,
  .fp-plans-grid--cols-3,
  .fp-plans-grid--cols-4 {
    grid-template-columns: min(var(--fp-plan-card-w), 100%);
  }
}
.fp-plan-card {
  box-sizing: border-box;
}
.fp-plan-data {
  width: 100%;
}
.fp-data-row__value {
  flex: 0 0 108px;
  width: 108px;
}
.fp-cta {
  isolation: isolate;
}
.fp-cta-shine {
  position: absolute;
  top: -45%;
  left: -30%;
  z-index: 0;
  width: 42%;
  height: 190%;
  background: linear-gradient(
    106deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0) 40%,
    rgba(255, 255, 255, 0.55) 50%,
    rgba(255, 255, 255, 0) 60%,
    rgba(255, 255, 255, 0) 100%
  );
  opacity: 0.55;
  transform: skewX(-22deg) translate3d(-140%, 0, 0);
  animation: fp-cta-stream 3.4s ease-in-out infinite;
  will-change: transform;
}
@media (prefers-reduced-motion: reduce) {
  .fp-cta-shine {
    animation: none;
    opacity: 0;
  }
}
@keyframes fp-cta-stream {
  0% {
    transform: skewX(-22deg) translate3d(-140%, 0, 0);
  }
  42% {
    transform: skewX(-22deg) translate3d(340%, 0, 0);
  }
  100% {
    transform: skewX(-22deg) translate3d(340%, 0, 0);
  }
}
.fp-discount-chip {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}
.fp-discount-chip--green {
  background: rgba(12, 38, 26, 0.78);
  color: #a8ebc8;
  border-color: rgba(52, 211, 153, 0.28);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.07),
    0 4px 14px rgba(0, 0, 0, 0.35);
}
.fp-discount-chip--orange {
  background: rgba(38, 26, 14, 0.8);
  color: #fcd9a8;
  border-color: rgba(251, 146, 60, 0.28);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 4px 14px rgba(0, 0, 0, 0.35);
}
.fp-discount-chip--red {
  background: rgba(38, 14, 18, 0.8);
  color: #fecdd3;
  border-color: rgba(248, 113, 113, 0.3);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 4px 14px rgba(0, 0, 0, 0.35);
}
</style>
